import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class OpenShift extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M6.962,10.866l-3.854,1.4a11.2,11.2,0,0,0,.3,1.828l3.662-1.334a7.147,7.147,0,0,1-.113-1.9" />
        <path d="M24,6.605a10.919,10.919,0,0,0-.945-1.6L19.2,6.412a7.188,7.188,0,0,1,1.132,1.525Z" />
        <path d="M15.519,5.512A7.108,7.108,0,0,1,17.6,7l3.856-1.4A11.017,11.017,0,0,0,1.5,12.863l3.849-1.412A7.144,7.144,0,0,1,15.513,5.512" />
        <path d="M3.654,14.01,0,15.344a11.171,11.171,0,0,0,1.721,3.732l3.837-1.4a7.2,7.2,0,0,1-1.906-3.666" />
        <path d="M19.63,12.556a7.053,7.053,0,0,1-.647,2.471A7.167,7.167,0,0,1,9.469,18.5a7.074,7.074,0,0,1-2.087-1.482L3.53,18.421A10.93,10.93,0,0,0,7.822,22a11.04,11.04,0,0,0,14.653-5.334,10.923,10.923,0,0,0,.992-5.506Z" />
        <path d="M20.585,7.851,16.923,9.185a7.187,7.187,0,0,1,.9,4.032l3.848-1.4a11.113,11.113,0,0,0-1.083-3.968" />
        <path d="M6.947,11.642a7.141,7.141,0,0,1,.015-.774l-3.854,1.4c.019.247.052.492.089.737Z" />
        <path d="M23.44,5.59c-.121-.205-.247-.391-.381-.58l-3.853,1.4a6.433,6.433,0,0,1,.473.545Z" />
        <path d="M3.53,18.421a11.062,11.062,0,0,0,.98,1.19L8.7,18.083a7.044,7.044,0,0,1-1.321-1.064Zm19.937-7.264-3.845,1.4A7.061,7.061,0,0,1,19.3,14.2l4.187-1.527a10.976,10.976,0,0,0-.014-1.528" />
      </svg>
    );
  }
}

export default OpenShift;
